import axios, { AxiosResponse } from 'axios'
import { PageResponseAtendimentoList } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const ATENDIMENTO_URL = `${API_URL}/atendimentos/`

/**
 * Busca atendimentos
 * @param query string
 * @returns PageResponseAtendimentoList
 */
export const getAtendimentos = (query: string): Promise<PageResponseAtendimentoList> => {
  return axios
    .get(`${ATENDIMENTO_URL}?${query}`)
    .then((resp: AxiosResponse<PageResponseAtendimentoList>) => resp.data)
}
